/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BlobInfo } from './BlobInfo';
import {
    BlobInfoFromJSON,
    BlobInfoFromJSONTyped,
    BlobInfoToJSON,
} from './BlobInfo';

/**
 * 
 * @export
 * @interface TrackInspect
 */
export interface TrackInspect {
    /**
     * 
     * @type {BlobInfo}
     * @memberof TrackInspect
     */
    data?: BlobInfo;
}

/**
 * Check if a given object implements the TrackInspect interface.
 */
export function instanceOfTrackInspect(value: object): value is TrackInspect {
    let isInstance = true;

    return isInstance;
}

export function TrackInspectFromJSON(json: any): TrackInspect {
    return TrackInspectFromJSONTyped(json, false);
}

export function TrackInspectFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackInspect {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : BlobInfoFromJSON(json['data']),
    };
}

export function TrackInspectToJSON(value?: TrackInspect | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': BlobInfoToJSON(value.data),
    };
}

